import { Box } from '@mui/material';
import { useGoalCategory } from '@hc/store/backoffice/masters/goalCategory';
import PropTypes from 'prop-types';
import { Button, Drawer, Input, Label } from '@hc/ui/atoms';
import { goalCategoryDrawer_style } from './style';

function GoalCategoryDrawer(props) {
  const {
    drawerOpen = false,
    closeMasterDrawer = () => false,
    upsertMaster = () => {},
  } = props;

  const { handleChange, goal_name, goal_id } = useGoalCategory((state) => ({
    handleChange: state.handleChange,
    goal_name: state.goal_name,
    goal_id: state.goal_id,
  }));

  return (
    <Box>
      {drawerOpen && (
        <Drawer
          show={drawerOpen}
          onCloseDrawer={closeMasterDrawer}
          anchor="right"
          isCloseIconRequired
          header={`${goal_id ? 'Update' : 'Add'} Goal Category`}
          headerStyle={goalCategoryDrawer_style.drawerHeadSx}
          footerStyle={{ borderTop: '0px', py: 2.8, px: 2 }}
          footer={
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                buttonStyle={goalCategoryDrawer_style.saveBtnSx}
                onClick={upsertMaster}
              >
                {goal_id ? 'Update' : 'Add'}
              </Button>
              <Button
                buttonStyle={goalCategoryDrawer_style.cancleBtnSx}
                onClick={closeMasterDrawer}
              >
                Cancel
              </Button>
            </Box>
          }
        >
          <Box sx={goalCategoryDrawer_style.boxRootSx}>
            <Box sx={goalCategoryDrawer_style.inputGroupSx}>
              <Label
                rootStyle={goalCategoryDrawer_style.labelSx}
                htmlFor="GoalCategory"
                isRequired
              >
                Goal Category
              </Label>
              <Input
                id="GoalCategory"
                textFieldStyle={goalCategoryDrawer_style.inputFieldSx}
                onChange={(e) => handleChange(e.target.value)}
                fullWidth
                value={goal_name}
              />
            </Box>
          </Box>
        </Drawer>
      )}
    </Box>
  );
}

GoalCategoryDrawer.propTypes = {
  drawerOpen: PropTypes.bool,
  closeMasterDrawer: PropTypes.func,
};

export { GoalCategoryDrawer };
